import React from "react";
import { LocaleLink } from "../../i18n/LocaleLink";
import cn from "classnames";
import { getServices } from "../../data/services";
import { useTranslation } from "react-i18next";
export const ServicesDetailsSidebar = ({
  hideContact = false,
  hideTitle = false,
  serviceId,
}) => {
  const { t } = useTranslation();
  const services = getServices(t);

  return (
    <aside className="services-sidebar">
      {/* Our Services */}
      {hideTitle ? (
        <div className="services-cat-list mb-30">
          <ul className="list-wrap">
            {services.map((item, idx) => (
              <li key={idx} className={cn({ active: item.id === serviceId })}>
                <LocaleLink to={item.href} state={{ serviceId: item.id }}>
                  {item.title} <i className="flaticon-right-arrow"></i>
                </LocaleLink>
              </li>
            ))}
          </ul>
        </div>
      ) : (
        <div className="services-widget">
          <h4 className="sw-title">{t("servicesSidebar.ourServices")}</h4>
          <div className="services-cat-list">
            <ul className="list-wrap">
              {services.map((item, idx) => (
                <li key={idx} className={cn({ active: item.id === serviceId })}>
                  <LocaleLink to={item.href} state={{ serviceId: item.id }}>
                    {item.title} <i className="flaticon-right-arrow"></i>
                  </LocaleLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Brochure */}
      {/* <div className="services-widget">
        <h4 className="sw-title">Brochure</h4>
        <div className="services-brochure-wrap">
          <p>when an unknown printer took ga lley offer typey anddey.</p>
          <a
            href={SERVICES_DETAILS01}
            target="_blank"
            download
            className="download-btn"
          >
            <i className="far fa-file-pdf"></i>PDF. Download
          </a>
          <a
            href={SERVICES_DETAILS01}
            target="_blank"
            download
            className="download-btn"
          >
            <i className="far fa-file-alt"></i>DOC. Download
          </a>
        </div>
      </div> */}

      {/* contact */}
      {hideContact ? null : (
        <div className="services-widget services-sidebar-contact">
          <h4 className="title">{t("servicesSidebar.needHelp")}</h4>
          <a href="tel:0573044089089">
            <i className="flaticon-phone-call"></i> +57 304 408 9089
          </a>
        </div>
      )}

      {/* Get A Free Quote */}
      <div className="services-widget">
        <h4 className="sw-title">{t("servicesSidebar.freeCall")}</h4>
        <div className="services-widget-form">
          {/* <form action="#">
            <div className="form-grp">
              <input type="text" placeholder="Nombre" />
            </div>
            <div className="form-grp">
              <input type="text" placeholder="Teléfono" />
            </div>
            <div className="form-grp">
              <input type="email" placeholder="Correo electrónico" />
            </div>
            <div className="form-grp">
              <textarea
                name="message"
                placeholder="Escribe tu mensaje"
              ></textarea>
            </div>
            <button type="submit" className="submit-btn">
              Enviar
            </button>
          </form> */}
          <button type="submit" className="submit-btn" onClick={() => window.open("https://calendar.app.google/bvJMxpaXmpgWf7VS6", "_blank")}>
            {t("servicesSidebar.schedule")}
          </button>
        </div>
      </div>
    </aside>
  );
};
